import { Link } from '@mui/material';

import { useConfig } from '~/components/ConfigProvider';
import { useLocationLabel } from '~/hooks';
import { eventStopPropagation } from '~/util/function/eventStopPropagation';

export interface LocationLinkProps {
  value?: {
    city?: string | null;
    street?: string | null;
    postalCode?: string | null;
    countryCode?: string | null;
  } | null;
}

export const LocationLink = ({ value }: LocationLinkProps) => {
  const { getMapsUrl } = useConfig();
  const output = useLocationLabel(value);
  if (output) {
    return (
      <Link color="inherit" href={getMapsUrl(output)} target="_blank" rel="noreferrer" onClick={eventStopPropagation}>
        {output}
      </Link>
    );
  }
  return null;
};
